var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather09D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\xA0icon-09d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-icon-09d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,44 C15.4329966,44 17,42.1679661 17,39.9080379 C17,38.401419 15.8333333,36.0987397 13.5,33 C11.1666667,36.0987397 10,38.401419 10,39.9080379 C10,42.1679661 11.5670034,44 13.5,44 Z",
    id: "Oval-11",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,56 C30.4329966,56 32,54.1679661 32,51.9080379 C32,50.401419 30.8333333,48.0987397 28.5,45 C26.1666667,48.0987397 25,50.401419 25,51.9080379 C25,54.1679661 26.5670034,56 28.5,56 Z",
    id: "Oval-11-Copy",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,46 C44.4329966,46 46,44.1679661 46,41.9080379 C46,40.401419 44.8333333,38.0987397 42.5,35 C40.1666667,38.0987397 39,40.401419 39,41.9080379 C39,44.1679661 40.5670034,46 42.5,46 Z",
    id: "Oval-11-Copy-2",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5957673,30.7866961 C40.9460379,32.1682664 38.8201499,33 36.5,33 C34.2383018,33 32.1612006,32.2096463 30.52982,30.8900625 C28.7920918,32.8006439 26.2861082,34 23.5,34 C20.2213734,34 17.3306641,32.3391282 15.6233319,29.8128443 C14.2406266,30.571195 12.6680051,31 11,31 C5.4771525,31 1,26.2989899 1,20.5 C1,15.3123293 4.58296017,11.0033461 9.2922561,10.152506 C10.3372604,6.0411421 14.0634818,3 18.5,3 C20.4869426,3 22.3314144,3.60999017 23.8563644,4.65291957 C26.5050218,1.79138371 30.2933109,0 34.5,0 C41.3213409,0 47.0425355,4.71028611 48.5884592,11.0557337 C53.8759998,11.6003041 58,16.0685461 58,21.5 C58,27.2989899 53.2989899,32 47.5,32 C45.7285644,32 44.0595855,31.5613307 42.5957673,30.7866961 Z",
    id: "Combined-Shape-Copy-3",
    stroke: "#0A6EAC",
    fill: "#59A5D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather09D);
export default __webpack_public_path__ + "static/media/icon-weather-09d.86a40bb7f27090adcf38053905d9805c.svg";
export { ForwardRef as ReactComponent };